import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseIcon from '@/components/BaseIcon.vue'
enum TOURINGERY_LOGO_ICONS {
  PROVIDER = 'logo-provider',
  PUBLIC = 'logo-public',
  UNCOLORED = 'logo-with-name',
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TouringeryLogo',
  props: {
  width: {
    type: Number,
    default: 180,
  },
  height: {
    type: Number,
    default: 36,
  },
  icon: {
    type: String,
    default: 'logo-public',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseIcon, {
    icon: __props.icon,
    width: __props.width,
    height: __props.height
  }, null, 8, ["icon", "width", "height"]))
}
}

})